const state = {
  visitedViews: [],
  cachedViews: [],
  routes: [],
}

const mutations = {
  SET_STATE(state, obj) {
    for (let key in obj) {
      state[key] = obj[key]
    }
  },
  ADD_VISITED_VIEW: (state, view) => {
    let visitedView = state.visitedViews.find(item => item.path === view.path);
    // if (state.visitedViews.some(v => v.path === view.path)) {
    if (visitedView) {
      if (visitedView.fullPath != view.fullPath) {
        visitedView.fullPath = view.fullPath;
        visitedView.query = view.query;
      }
      
      // 由于使用keepAlive缓存，如果重复打开缓存页面则执行内部init事件
      if (view.matched) {
        let matched = view.matched.find(item => item.path == view.path);
        if (matched && matched.instances) {
          let _that = matched.instances.default;
          _that && _that.init && _that.init()
          if (visitedView.title != view.meta.title) {
            visitedView.title = view.meta.title;
          }
        }
      }
      return
    }
    state.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta.title || 'no-name'
      })
    )
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        // DEL_KEEPALIVE_VIEW(state, view)
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    index > -1 && state.cachedViews.splice(index, 1)
  },

  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    state.visitedViews = state.visitedViews.filter(v => {
      if (v.meta.affix || v.path === view.path) {
        return true
      }
      // DEL_KEEPALIVE_VIEW(state, v)
      return false
    })
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
  },

  DEL_ALL_VISITED_VIEWS: state => {
    // keep affix tags
    const affixTags = state.visitedViews.filter(tag => {
      // if (!tag.meta.affix) {
      //   DEL_KEEPALIVE_VIEW(state, tag)
      // }
      return tag.meta.affix
    })
    state.visitedViews = affixTags
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = []
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view, {
          title: view.meta.title || 'no-name'
        })
        break
      }
    }
  }
}

const actions = {
  setState({
    dispatch,
    commit
  }, param) {
    commit('SET_STATE', param)
  },
  addView({
    dispatch
  }, view) {
    dispatch('addVisitedView', view)
    dispatch('addCachedView', view)
  },
  addVisitedView({
    commit
  }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  addCachedView({
    commit
  }, view) {
    commit('ADD_CACHED_VIEW', view)
  },

  delView({
    dispatch,
    state
  }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delVisitedView({
    commit,
    state
  }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({
    commit,
    state
  }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },

  delOthersViews({
    dispatch,
    state
  }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view)
      dispatch('delOthersCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delOthersVisitedViews({
    commit,
    state
  }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({
    commit,
    state
  }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.cachedViews])
    })
  },

  delAllViews({
    dispatch,
    state
  }, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view)
      dispatch('delAllCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delAllVisitedViews({
    commit,
    state
  }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({
    commit,
    state
  }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.cachedViews])
    })
  },

  updateVisitedView({
    commit
  }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  }
}

const DEL_KEEPALIVE_VIEW = function(state, view) {
  // 清除keepAlive缓存 有使用了keepAlive :include
  if (view.meta.keepAlive) {
    let matched = view.matched.find(item => item.path == view.path);
    let v = matched && matched.instances ? matched.instances.default : '';
    if (v && v.$vnode && v.$vnode.data.keepAlive) {
      if (v.$vnode.parent && v.$vnode.parent.componentInstance && v.$vnode.parent.componentInstance.cache) {
        if (v.$vnode.componentOptions) {
          var key = v.$vnode.key == null ? v.$vnode.componentOptions.Ctor.cid + (v.$vnode.componentOptions.tag ?
            `::${v.$vnode.componentOptions.tag}` : '') : v.$vnode.key;
          var cache = v.$vnode.parent.componentInstance.cache;
          var keys = v.$vnode.parent.componentInstance.keys;
          if (cache[key]) {
            if (keys.length) {
              var index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1);
              }
            }
            delete cache[key];
          }
        }
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js